<template>
  <normal-layout
      :title="'申请提现'"
      :content-background-color="'#f0f0f0'"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #content>
      <div class="withdraw-container">
        <div class="content-container">
          <p class="title">{{ typeTitle }}</p>

          <div class="input-container">
            <div class="input-wrap">
              <p class="money-icon">¥</p>
              <input class="money-input" type="text" :placeholder="minWithdraw" v-model="amount"
                     @input="checkInputValid"/>
            </div>
            <div class="function-wrap">
              <img v-show="clearEnable" class="clear" src="../../assets/images/wallet/pay_close.png"
                   @click="clearAmount" alt/>
              <p class="all" @click="setAmountMax">全部提现</p>
            </div>
          </div>
          <div class="separator"></div>
          <div class="money-all">
            <p>{{ maxWithdrawString }}</p>
            <p class="rest" v-if="showRest">{{ restAmount | restAmountString }}</p>
          </div>

          <div class="full-separator"></div>

          <div class="notice-container">
            <p>温馨提示:</p>
            <p>1.提现申请将于1-2个工作内完成审核</p>
            <p>2.提现时银行会收取一定比例的手续费</p>
            <p>{{ notice }}</p>
            <p class="alert">可提现到卡金额以最新申请金额为准</p>
          </div>

        </div>

        <p class="apply" :style="{backgroundColor: !submitEnable?'#8B8B8B' :'#EC2B24'}" @click="submitAmount">
          提交
        </p>
      </div>
      <bank-identity/>
    </template>
  </normal-layout>
</template>

<script>
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import BankIdentity from './components/BankIdentity'
import { Toast } from 'vant'
import { applyForCash } from '@/request/api.encryptor'
import { deviceType, showLoading, verdictEmpty } from '@/utils/tools'

export default {
  name: 'WithdrawApply',
  components: {
    NormalLayout,
    LeftButton,
    BankIdentity

  },
  data() {
    return {
      amount: '',
      maxAmount: 0, // 可申请提现金额
      restAmount: 0, // 剩余可申请提现金额
      acctAvailBal: 0, // 钱包余额
      submitting: false,
      timeoutFunc: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { acctAvailBal = 0, cashAmt = 0 } = this.$route.query || {}
      this.maxAmount = cashAmt
      this.acctAvailBal = acctAvailBal
      this.restAmount = acctAvailBal - cashAmt
    })
  },
  methods: {
    clearAmount() {
      this.amount = ''
    },
    setAmountMax() {
      this.amount = this.maxAmount
    },
    checkInputValid() {
      if (!/^\d+\.?\d{0,2}$/.test(this.amount)) {
        this.amount = this.amount.substring(0, this.amount.length - 1)
      }
      let amountString = String(this.amount)
      if (amountString.startsWith('0')) {
        amountString = amountString.substring(1)
        this.amount = Number(amountString)
      }
      let amountNum = Number(this.amount)
      if (Number.isNaN(amountNum)) {
        this.amount = 0
        return
      }
      if (amountNum > 500000) {
        if (this.maxAmount > 500000) {
          this.amount = 500000
          return
        } else {
          this.amount = this.maxAmount
          return
        }
      }
      if (amountNum > this.maxAmount) {
        this.amount = this.maxAmount
      }
    },
    submitAmount() {
      if (this.submitting) {
        return
      }
      this.submitting = true
      if (this.maxAmount < 10) {
        this.submitting = false
        Toast('最大可申请提现金额小于10元无法提现')
        return
      }
      let amountNum = Number.parseFloat(this.amount)
          .toFixed(2)
      if (verdictEmpty(this.amount) || amountNum.isNaN) {
        this.submitting = false
        this.amount = ''
        Toast('请输入正确的金额')
        return
      }
      if (amountNum < 10) {
        this.submitting = false
        Toast('最少可申请提现10元')
        return
      }
      if (amountNum > 500000) {
        this.submitting = false
        Toast('最多可申请提现50万元')
        return
      }
      if (amountNum > Number.parseFloat(this.maxAmount)) {
        this.submitting = false
        Toast('申请提现金额大于最大可提现金额')
        return
      }
      showLoading('请稍后...')
      const params = {
        tranAmt: this.amount,
        type: '00'
      }
      applyForCash(params)
          .then(res => {
            Toast.clear()
            const { status = 1, msg = '' } = res || {}
            if (status !== 0) {
              msg && Toast.fail(msg)
              return
            }
            this.$JD.nativeRouter({
              url: '/wallet/applyMoneyDetails',
              query: {
                money: this.amount,
                isRemoveLast: true
              }
            })
            if (deviceType()) {
              this.timer = setTimeout(() => {
                this.$JD.goBack()
                clearTimeout(this.timer)
              }, 400)
            }
          })
          .catch(error => {
            Toast.clear()
            error && Toast.fail(error)
          })
      this.timeoutFunc = setTimeout(() => {
        this.submitting = false
        clearTimeout(this.timeoutFunc)
      }, 3000)
    }
  },
  computed: {
    showRest() {
      return this.restAmount > 0
    },
    submitEnable() {
      let amountNum = Number(this.amount)
      return amountNum >= 10 && amountNum <= this.maxAmount
    },
    clearEnable() {
      return this.amount > 0
    },
    typeTitle() {
      return '提现金额'
    },
    minWithdraw() {
      return '申请提现金额不得少于10元'
    },
    maxWithdrawString() {
      return '可申请提现金额¥' + this.maxAmount
    },
    notice() {
      let keyword = '元'
      return '3.提现限额10' + keyword + '-50万' + keyword
    }
  },
  filters: {
    restAmountString(val) {
      let frontString = '(剩余¥'
      let behindString = ',平安银行资金清算时间为交易后第二天，节假日顺延，到账后可继续提现)'
      return frontString + val + behindString
    }
  }
}
</script>

<style lang="scss">
.withdraw-container {
  background-color: #f0f0f4;
  font-family: SourceHanSansCN-Normal;

  .content-container {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title {
      padding: 0.233rem 0.12rem;
      font-size: 0.2rem;
      color: #525252;
    }

    .input-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 0.67rem;
      padding: 0 0.1rem;
      width: 100%;

      .input-wrap {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .money-icon {
          flex-basis: 0.2rem;
          font-size: 0.3rem;
          padding: 0 0.05rem;
          color: #333333;
        }

        .money-input {
          width: 100%;
          height: 0.5rem;
          font-size: 0.3rem;
          color: #333333;
          outline: none;
          border: none;
          padding: 0 .1rem;
          margin: 0;
        }

        .money-input::placeholder {
          color: #c2c2c2;
          font-size: 0.2rem;
          line-height: 0.4rem;
        }

        .money-input::-webkit-input-placeholder {
          color: #c2c2c2;
          font-size: 0.2rem;
          line-height: 0.4rem;
        }
      }

      .function-wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        .clear {
          width: .2rem;
          height: 0.2rem;
          margin-left: .06rem;
        }

        .all {
          min-width: 0.9rem;
          font-size: 0.187rem;
          color: #769fea;
          text-align: center;
          padding-left: 0.1rem;
        }
      }
    }

    .separator {
      width: 95%;
      margin: 0 0.12rem;
      height: .5px;
      background-color: #F0F0F4;
    }

    .money-all {
      padding: 0.187rem 0.12rem;
      color: #525252;
      font-size: 0.2rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .rest {
        margin-top: 0.1rem;
        font-size: 0.16rem;
        color: #8b8b8b;
        line-height: .24rem;
        text-align: start;
      }
    }

    .full-separator {
      width: 100%;
      height: .5px;
      background-color: #f0f0f4;
    }

    .notice-container {
      padding: 0.213rem .167rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        font-size: 0.173rem;
        color: #8b8b8b;
        line-height: .24rem;
      }

      .alert {
        margin-top: 0.1rem;
        font-size: .173rem;
        color: #EC2B24;
      }
    }
  }

  .apply {
    display: flex;
    align-items: center;
    justify-content: center;
    height: .56rem;
    flex: 1;
    margin: .527rem .167rem;
    border-radius: .053rem;
    font-size: .213rem;
    color: white;
  }
}
</style>
